<template>
  <v-row justify="space-between" align="center" class="ma-0">
    <v-breadcrumbs :items="crumbs" divider="/"></v-breadcrumbs>
    <v-btn icon="mdi-plus" density="comfortable" @click="openAddModal" id="show-modal"></v-btn>
  </v-row>
  <v-row>
    <v-col cols="12" md="12">
      <v-card :elevation="1">
        <v-card-text>
          <v-table v-if="watchlistItems.length > 0">
            <thead>
              <tr>
                <th class="table-heading-text">ticker</th>
                <th class="table-heading-text text-center">current price</th>
                <th class="table-heading-text text-center">alert above</th>
                <th class="table-heading-text text-center">alert below</th>
                <th class="table-heading-text text-center">alert status</th>
                <th class="table-heading-text text-right">actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in watchlistItems" :key="item.id">
                <td class="table-content-text text-left">{{ item.ticker }}</td>
                <td class="table-content-text">{{ item.current_price != null ? '$' + Number(item.current_price).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-' }}</td>
                <td class="table-content-text">{{ item.alert_above != null ? '$' + Number(item.alert_above).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-' }}</td>
                <td class="table-content-text">{{ item.alert_below != null ? '$' + Number(item.alert_below).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-' }}</td>
                <td class="table-content-text">
                  <v-chip :color="item.alert_active ? 'green' : 'grey'" size="small">
                    {{ item.alert_active ? 'active' : 'triggered' }}
                  </v-chip>
                </td>
                <td class="text-right">
                  <v-btn icon="mdi-pencil-outline" variant="text" size="small" @click="openEditModal(item)"></v-btn>
                  <v-btn icon="mdi-delete-outline" variant="text" size="small" @click="deleteItem(item.id)"></v-btn>
                </td>
              </tr>
            </tbody>
          </v-table>
          <div v-else class="text-center pa-8">
            <v-icon size="64" color="grey-lighten-1">mdi-eye-off-outline</v-icon>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>

  <!-- Modals -->
  <WatchlistItemModal :show="showModal" :editItem="selectedItem" @close="closeModal"></WatchlistItemModal>

</template>

<script>
import axios from 'axios';
import WatchlistItemModal from './modals/WatchlistItemModal.vue';
import { mapState, mapMutations } from 'vuex';

export default {
  components: {
    WatchlistItemModal
  },
  data() {
    return {
      watchlistItems: [],
      showModal: false,
      selectedItem: null
    };
  },
  async created() {
    this.getWatchlist();
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    crumbs() {
      return [
        {
          title: 'watchlist',
          disabled: true,
          href: ''
        },
      ];
    },
  },
  methods: {
    ...mapMutations(["showSnackbar"]),
    async getWatchlist() {
      try {
        const response = await axios.get('/securities/watchlist/');
        this.watchlistItems = response.data;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load watchlist' });
      }
    },
    openAddModal() {
      this.selectedItem = null;
      this.showModal = true;
    },
    openEditModal(item) {
      this.selectedItem = item;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.selectedItem = null;
      this.getWatchlist();
    },
    async deleteItem(id) {
      try {
        await axios.delete(`/securities/watchlist/${id}`);
        this.getWatchlist();
      } catch (error) {
        this.showSnackbar({ message: 'Failed to delete watchlist item' });
      }
    }
  }
};
</script>
